import 'react-dates/initialize';
import React, { Component } from 'react';
import { Link } from 'react-router';
import Navigator from 'components/NavigatorComponent';
import Moment from 'moment';
import { DayPickerSingleDateController } from 'react-dates';
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import aphroditeInterface from 'react-with-styles-interface-aphrodite';
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme';
import API from 'sources/API';

ThemedStyleSheet.registerInterface(aphroditeInterface);
ThemedStyleSheet.registerTheme({
  reactDates: {
    ...DefaultTheme.reactDates,
    color: {
      ...DefaultTheme.reactDates.color,
      highlighted: {
        backgroundColor: '#82E0AA',
        backgroundColor_active: '#58D68D',
        backgroundColor_hover: '#58D68D',
        color: '#186A3B',
        color_active: '#186A3B',
        color_hover: '#186A3B'
      }
    }
  }
});

require('react-dates/lib/css/_datepicker.css');
require('./Teams.scss');

import TeamStore from 'stores/TeamStore';
import TeamActions from 'actions/TeamActions';

const CustomInfoPanel = () => (
  <div
    style={{
      padding: '10px 21px',
      borderTop: '1px solid #dce0e0',
      color: 'olivedrab',
      fontSize: '12px'
    }}
  >
    &#x2755; 高亮当日存在团期，请仔细核对
  </div>
);

class TeamsComponent extends Component{
  constructor(props) {
    super(props);
    let teamstore = TeamStore.getState();
    this.state = {
      date: teamstore.date,
      teams: teamstore.teams,
      starts: teamstore.starts,
      showNavigator: false,
      focused: true
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.onTeamsChange = this.onTeamsChange.bind(this);
    this.onTeamsScroll = this.onTeamsScroll.bind(this);
  }
  componentWillMount(){
    let teamstore = TeamStore.getState();
    TeamActions.fetchTeams({time:teamstore.date.format('YYYY-MM-DD')})
    TeamActions.fetchTeamStarts({time:teamstore.date.format('YYYY-MM')})
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }

    window.scrollTo(0, 0);
    TeamStore.listen(this.onTeamsChange);
    window.addEventListener('scroll',this.onTeamsScroll);

    window.changeMetaForSEO(false);
    
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount(){
    TeamStore.unlisten(this.onTeamsChange);
    TeamActions.updateDay(this.state.date);
    window.removeEventListener('scroll',this.onTeamsScroll);
  }
  onDateChange(date) {
    this.setState({date})
    TeamActions.fetchTeams({time:date.format('YYYY-MM-DD')})
  }
  onTeamsChange(state) {
    this.setState({
      teams: state.teams,
      starts: state.starts
    })
  }
  onTeamsScroll(){
    let scrollTop = $(document).scrollTop();
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  render(){
    let teams;
    if(this.state.teams.length){
      teams = [];
      this.state.teams.map((team) => {
        teams.push(<Link key={team._id} to={`/route/${team.product._id}`} className="team">
          <div className="cover">
            <img src={team.product.cover.big}></img>
          </div>
          <div className="price fw-bold">¥{team.standard_price}</div>
          <div className="title fz-16 fw-bold">{team.product.title}</div>
          <div className="time fz-12 fw-bold">团期：<span style={{color:'lightcoral'}}>{team.start_date} ～ {team.end_date}</span></div>
        </Link>)
      })
    }else{
      teams = (
        <div className="empty fz-12">～当日没有团期，所有行程两人任意时间即可出发～</div>
      )
    }
    let navigator;
    if(this.state.showNavigator){
      navigator = <Navigator action='top' number="2"/>
    }
    return (
      <div className="teams-component ">
        <div className="date card">
          <p className="cat">出行日期</p>
          <DayPickerSingleDateController
            date={this.state.date}
            onDateChange={this.onDateChange}
            focused={true} // PropTypes.bool
            monthFormat={'YYYY年 MM月'}
            isOutsideRange={(day) => day.isBefore(Moment().subtract(1,'day'))}
            isDayHighlighted={(day) =>  this.state.starts.indexOf(day.format('YYYY-MM-DD')) >= 0}
            onPrevMonthClick={(day) => {TeamActions.fetchTeamStarts({time:day.format('YYYY-MM')});this.setState({date:day}); TeamActions.fetchTeams({time:day.format('YYYY-MM-DD')});}}
            onNextMonthClick={(day) => {console.log(day.format('YYYY-MM-DD'));TeamActions.fetchTeamStarts({time:day.format('YYYY-MM')});this.setState({date:day}); TeamActions.fetchTeams({time:day.format('YYYY-MM-DD')});}}
            initialVisibleMonth={() => this.state.date}
            renderCalendarInfo={() => (
              <CustomInfoPanel />
            )}
          />
        </div>
        <div className="teams card">
          {teams}
        </div>
        {navigator}
        <Navigator action='left' />
      </div>
    );
  }
}

export default TeamsComponent;




// WEBPACK FOOTER //
// ./src/develop/TeamsComponent.js